// VIDEO VIEWS
export enum AspectRatio {
  HORIZONTAL = "16:9",
  VERTICAL = "9:16",
}

export enum Orientation {
  PORTRAIT = "Portrait",
  LANDSCAPE = "Landscape",
}

// Layouts for the embeddable rozy player
export enum RozyLayout {
  DESKTOP = "Desktop",
  MOBILE = "Mobile",
}
